// services/EmailSubscriptionService.js
import axios from "axios";
import { getConfig } from "../configService";

export class EmailSubscriptionService {
    static getBaseUrl() {
        if (
            (window.location.hostname === "localhost" ||
                window.location.hostname === "127.0.0.1") &&
            getConfig().localhostApi
        ) {
            return "http://localhost:5051/v1"; // version 1.0 of the API
        }
        return getConfig().apiBaseUrl + "/email-subscription-service/v1"; // use a distinct base path if needed
    }

    /**
     * Unsubscribes the given email from the specified domain
     * @param {string} email - The email address to unsubscribe
     * @param {string} domain - The domain from which to unsubscribe
     * @returns {Promise} Axios response
     */
    static async unsubscribe(email, domain) {
        try {
            const baseUrl = EmailSubscriptionService.getBaseUrl();
            const url = `${baseUrl}/Unsubscribe/${domain}/${encodeURIComponent(email)}`;

            return await axios.post(url, null, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
        } catch (error) {
            console.error("Unsubscribe error:", error);
            return error.response;
        }
    }
}
